import { default as localeData } from '../locales/moment'

let i18n = {}

switch (document.documentElement.lang || 'en-gb') {
  case 'de':
    i18n = {
      previousMonth: 'vorheriger Monat', nextMonth: 'nächster Monat',
    }
    break
  case 'en-gb':
    i18n = {
      previousMonth: 'Previous Month', nextMonth: 'Next Month',
    }
    break
  case 'nl':
    i18n = {
      previousMonth: 'Vorig maand', nextMonth: 'Volgende maand',
    }
    break
  case 'fr':
    i18n = {
      previousMonth: 'Mois précédent', nextMonth: 'Mois prochain',
    }
    break
  case 'es':
    i18n = {
      previousMonth: 'Previous Month', nextMonth: 'Next Month',
    }
    break
  case 'it':
    i18n = {
      previousMonth: 'Previous Month', nextMonth: 'Next Month',
    }
    break
  case 'pl':
    i18n = {
      previousMonth: 'Previous Month', nextMonth: 'Next Month',
    }
    break
  case 'sv':
    i18n = {
      previousMonth: 'Previous Month', nextMonth: 'Next Month',
    }
    break
  case 'ru':
    i18n = {
      previousMonth: 'Previous Month', nextMonth: 'Next Month',
    }
    break
  case 'zh-cn':
    i18n = {
      previousMonth: 'Previous Month', nextMonth: 'Next Month',
    }
    break
}

export default localeData.then((locale) => {
  i18n.months = locale.months
  i18n.weekdays = locale.weekdays
  i18n.weekdaysShort = locale.weekdays.map(weekday => weekday.substr(0, 2))

  return i18n
}).then(i18n => ({
  formatStrict: true,
  firstDay: 1,
  setDefaultDate: true,
  i18n: i18n
}))
